import { useTranslation } from 'translations/hooks';

import { AggregatedTaskPieChart } from 'business/shift-report/report/pages/ReportAggregated/components/aggregated-task-pie-chart';

import { TopLevelTasksAggregate } from './types';

interface AggregatedGraphProps {
  topLevelTasksAggregate: TopLevelTasksAggregate[];
  criticalTime?: boolean;
  title?: string;
}

export default function AggregatedGraph({
  topLevelTasksAggregate,
  criticalTime = false,
  title,
}: AggregatedGraphProps) {
  const { t } = useTranslation();

  const defaultTitle = `${t('pages.print.shiftProductionTime', {
    context: 'firstLevel',
  })} - ${t('pages.print.totalCriticalTime')}`;

  return (
    <div key="graph-container" className="bloc">
      <h1>{title ? title : defaultTitle}</h1>
      <AggregatedTaskPieChart
        aggregatedTasks={topLevelTasksAggregate}
        criticalTime={criticalTime}
      />
    </div>
  );
}
